import { Controller } from "@hotwired/stimulus"

// Handles global keyboard shortcut to show help modal
// Press "?" to show keyboard shortcuts modal
export default class extends Controller {
  connect() {
    this.boundKeydownHandler = this.handleKeydown.bind(this)
    document.addEventListener('keydown', this.boundKeydownHandler)
  }

  disconnect() {
    document.removeEventListener('keydown', this.boundKeydownHandler)
  }

  handleKeydown(event) {
    // Skip if in an input field
    if (event.target.tagName === 'INPUT' ||
        event.target.tagName === 'TEXTAREA' ||
        event.target.tagName === 'SELECT' ||
        event.target.isContentEditable) {
      return
    }

    // Show help modal on "?" key
    if (event.key === '?') {
      event.preventDefault()
      this.showHelpModal()
    }
  }

  showHelpModal() {
    const modal = document.getElementById('keyboardShortcutsModal')
    if (modal) {
      const bsModal = new bootstrap.Modal(modal)
      bsModal.show()
    }
  }
}
